import React from 'react';
import './PageNotFound.css';
import { useTranslation } from '../../i18n/LanguageContext';

const PageNotFound = () => {
  const { translate } = useTranslation();
  return (
    <div className="pnf" data-testid="pnf-container">
      <h1 className="pnf-title">404</h1>
      <h2 className="pnf-heading">{translate('pageNotFound', 'pageNotFoundText')}</h2>
    </div>
  );
};

export default PageNotFound;
